(function () {
  'use strict';

  function init() {

    const productId = document.querySelector('[data-product-id]')?.dataset.productId || 'default';

    // Load saved data
    const stored = localStorage.getItem('custom_size_' + productId);

    if (stored) {
      const data = JSON.parse(stored);

      document.querySelectorAll('.csm-input').forEach(input => {
        if (data[input.name]) {
          input.value = data[input.name];
        }
      });

      document.querySelectorAll('[id^="csm-summary-"]').forEach(el => {
        const sectionId = el.id.replace('csm-summary-', '');
        renderSummary(sectionId, data);
      });
    }

    // Toggle modal
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-csm-target]');
      if (!btn) return;

      const panelId = btn.dataset.csmTarget.replace('csm-modal-', 'csm-panel-');
      const panel = document.getElementById(panelId);
      if (!panel) return;

      if (panel.hasAttribute('hidden')) {
        panel.removeAttribute('hidden');
        requestAnimationFrame(() => {
          panel.classList.add('csm-panel--open');
        });
      } else {
        panel.classList.remove('csm-panel--open');
        panel.setAttribute('hidden', '');
      }
    });

    // Save
    document.addEventListener('click', function (e) {
      const saveBtn = e.target.closest('[data-csm-save]');
      if (!saveBtn) return;

      const sectionId = saveBtn.dataset.csmPanel;
      const panel = document.getElementById('csm-panel-' + sectionId);
      if (!panel) return;

      const inputs = panel.querySelectorAll('.csm-input');
      let data = {};

      inputs.forEach(input => {
        if (input.name && input.value) {
          data[input.name] = input.value;
        }
      });

      if (Object.keys(data).length === 0) {
        alert('Please enter at least one measurement');
        return;
      }

      localStorage.setItem('custom_size_' + productId, JSON.stringify(data));

      renderSummary(sectionId, data);

      panel.classList.remove('csm-panel--open');
      panel.setAttribute('hidden', '');
    });

    function renderSummary(sectionId, data) {
      const container = document.getElementById('csm-summary-' + sectionId);
      if (!container) return;

      const content = container.querySelector('.csm-summary-content');

      let html = '<div class="csm-summary-grid">';

      Object.entries(data).forEach(([key, value]) => {
        if (!value || value === '0') return; // skip empty

        const label = key.replace('properties[', '').replace(']', '');

        html += `
          <div class="csm-row">
            <span class="csm-label">${label}</span>
            <span class="csm-value">${value}</span>
          </div>
        `;
      });

      html += '</div>';

      content.innerHTML = html;
      container.style.display = 'block';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();